const podcasts = [
	// Shows
	{
		path: '/agency/podcasts/shows/list',
		name: 'agency-podcasts-shows-list',
		component: () => import('@/views/agency/podcasts/shows/list.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	{
		path: '/agency/podcasts/shows/create',
		name: 'agency-podcasts-shows-create',
		component: () => import('@/views/agency/podcasts/shows/new.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	{
		path: '/agency/podcasts/shows/edit/:id',
		name: 'agency-podcasts-shows-edit',
		component: () => import('@/views/agency/podcasts/shows/new.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	// Episodes
	{
		path: '/agency/podcasts/episodes/list',
		name: 'agency-podcasts-episodes-list',
		component: () => import('@/views/agency/podcasts/episodes/list.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	{
		path: '/agency/podcasts/episodes/create',
		name: 'agency-podcasts-episodes-create',
		component: () => import('@/views/agency/podcasts/episodes/new.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	{
		path: '/agency/podcasts/episodes/edit/:id',
		name: 'agency-podcasts-episodes-edit',
		component: () => import('@/views/agency/podcasts/episodes/new.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	// Guests
	{
		path: '/agency/podcasts/guests/list',
		name: 'agency-podcasts-guests-list',
		component: () => import('@/views/agency/podcasts/guests/list.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	{
		path: '/agency/podcasts/guests/create',
		name: 'agency-podcasts-guests-create',
		component: () => import('@/views/agency/podcasts/guests/new.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	{
		path: '/agency/podcasts/guests/edit/:id',
		name: 'agency-podcasts-guests-edit',
		component: () => import('@/views/agency/podcasts/guests/new.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	// Hosts
	{
		path: '/agency/podcasts/hosts/list',
		name: 'agency-podcasts-hosts-list',
		component: () => import('@/views/agency/podcasts/hosts/list.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	{
		path: '/agency/podcasts/hosts/create',
		name: 'agency-podcasts-hosts-create',
		component: () => import('@/views/agency/podcasts/hosts/new.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	{
		path: '/agency/podcasts/hosts/edit/:id',
		name: 'agency-podcasts-hosts-edit',
		component: () => import('@/views/agency/podcasts/hosts/new.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	// Sponsors
	{
		path: '/agency/podcasts/sponsors/list',
		name: 'agency-podcasts-sponsors-list',
		component: () => import('@/views/agency/podcasts/sponsors/list.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	{
		path: '/agency/podcasts/sponsors/create',
		name: 'agency-podcasts-sponsors-create',
		component: () => import('@/views/agency/podcasts/sponsors/new.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	{
		path: '/agency/podcasts/sponsors/edit/:id',
		name: 'agency-podcasts-sponsors-edit',
		component: () => import('@/views/agency/podcasts/sponsors/new.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	// Consents (read-only)
	{
		path: '/agency/podcasts/consents/list',
		name: 'agency-podcasts-consents-list',
		component: () => import('@/views/agency/podcasts/consents/list.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	// Recording Slots
	{
		path: '/agency/podcasts/slots/list',
		name: 'agency-podcasts-slots-list',
		component: () => import('@/views/agency/podcasts/slots/list.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
	// Calendar
	{
		path: '/agency/podcasts/calendar',
		name: 'agency-podcasts-calendar',
		component: () => import('@/views/agency/podcasts/calendar/index.vue'),
		meta: { layout: 'content', module: 'MGAG,podcasts' },
	},
]

export default podcasts
